import Modal from "../shared/Modal";
import "./ModalConsent.css"; // We'll reuse the same styles

type ModalHrisConnectedProps = {
  isOpen: boolean;
  onClose: () => void;
};

const ModalHrisConnected = ({ isOpen, onClose }: ModalHrisConnectedProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      style={null}
      onClose={onClose}
      canClose={true}
      allowClickout={true}>
      <div id="modal-collection-consent">
        <div className="modal-collection-consent-title">
          HRIS Connected Successfully
        </div>

        <div className="modal-collection-consent-content">
          <p>
            Your HRIS integration has been connected successfully. Please note
            that it may take a while for your HRIS data to be fully populated in
            the system.
          </p>
        </div>

        <div className="modal-collection-consent-footer">
          <div className="modal-collection-consent-buttons">
            <button onClick={onClose} className="collections-button">
              Got it
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalHrisConnected;
